import { Component, OnInit } from '@angular/core';
import {Story} from '../../models/story';
import {DataService} from '../../services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ServerResponse} from '../../models/server-response.model';
import swal from 'sweetalert';
import {Route, SERVER_IMAGE_PATH} from '../../utils/constant';
import {schools} from '../../models/schools';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-delete-schools',
  templateUrl: './delete-schools.component.html',
  styleUrls: ['./delete-schools.component.css']
})

export class DeleteSchoolsComponent implements OnInit {
  school$ = new schools();
  constructor(private data: DataService,private users: UserService, private route: ActivatedRoute, private router: Router) {
    this.route.params.subscribe(params => this.school$.id = params.id);
  }
  
  ngOnInit() {
    this.data.getSchoolsById(this.school$.id).subscribe((data: ServerResponse) => {
      this.school$ = data.data;
  });
  }

  deleteSchool(id) {
    swal({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover School!',
      icon: 'warning',
      buttons: [true , true],
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
        this.data.deleteSchools({id: id}).subscribe((response: ServerResponse) => {
          console.log('response', response);
          if (response.error === 0 && response.authError === 0) {
            swal({
              title: 'Message',
              text: 'School has been deleted Successfully!',
              icon: 'success'
            });
          }
          this.router.navigate(['/' + Route.schools]).catch(reason => {
            console.log('reason', reason);
          });
        });

      } else {
        swal('School is safe!');
      }
    });
  }
  formReset() {
    this.router.navigate(['/' + Route.schools]);
  }
}
